import React from 'react'

import './card-chat.scss'

const CardChat = ({ children, iconUser, chatNosotras, className }) => {
  return (
    <div className={`f-cardChat-container ${className && className}`}>
      <img
        className={`f-cardChat-container__iconUser ${
          chatNosotras && 'f-cardChat-container__iconUser--right'
        }`}
        src={iconUser}
        alt="icono de usuaria"
      />
      <div className={`f-cardChat-container__info ${className && className}`}>
        <p className={`f-cardChar-textInfo ${className && className}`}>
          {children}
        </p>
      </div>
    </div>
  )
}

export default CardChat
